import React from 'react';
import Loader from '@asphalt-react/loader';

function LoadingPage() {
    const loaderContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
    };
    return (
        <div style={loaderContainerStyle}>
            <Loader size='l' />
        </div>
    );
}

export default LoadingPage;
